
import React from 'react';
import { CheckCircle } from 'lucide-react';

const WhyChooseSection = () => {
  const whyChooseFeatures = [
    "Top-Tier Brand Partnerships: IKO, Atlas, CertainTeed, GAF, Owens Corning, Ames",
    "Certified Technicians",
    "5+ Year Workmanship Warranty",
    "Live Communication, Fast Turnarounds",
    "5-Star Local Reputation"
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl font-bold mb-4">🛡️ Why Choose Carolina Trophy Roofs?</h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid gap-4">
            {whyChooseFeatures.map((feature, index) => (
              <div key={index} className="flex items-center bg-white p-4 rounded-lg shadow-sm">
                <CheckCircle className="h-6 w-6 text-green-500 mr-4 flex-shrink-0" />
                <span className="font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
